<canvas #canvas></canvas>

<div class="">
    <button class="btn btn-primary" (click)="clear()">Clear</button>
</div>